import React, { useEffect } from 'react';
import TermsContent from './TermsContent';

interface TermsBottomSheetProps {
  open: boolean;
  onClose: () => void;
}

const overlayStyle: React.CSSProperties = {
  position: 'fixed',
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
  background: 'rgba(0,0,0,0.5)',
  display: 'flex',
  alignItems: 'flex-end',
  justifyContent: 'center',
  zIndex: 1000
};

const sheetStyle: React.CSSProperties = {
  width: '100%',
  maxWidth: 900,
  background: 'var(--color-bg-card)',
  color: 'var(--color-text-primary)',
  borderTopLeftRadius: 16,
  borderTopRightRadius: 16,
  border: '1px solid var(--color-border-primary)',
  boxShadow: '0 -8px 24px rgba(0,0,0,0.2)',
  transform: 'translateY(0)',
  transition: 'transform 200ms ease-out',
  maxHeight: '85vh',
  overflowY: 'auto'
};

const headerStyle: React.CSSProperties = {
  position: 'sticky',
  top: 0,
  background: 'var(--color-bg-card)',
  borderBottom: '1px solid var(--color-border-primary)',
  padding: '12px 16px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  zIndex: 1
};

const bodyStyle: React.CSSProperties = {
  padding: 16,
  paddingBottom: 'calc(16px + env(safe-area-inset-bottom, 0px))'
};

const TermsBottomSheet: React.FC<TermsBottomSheetProps> = ({ open, onClose }) => {
  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  if (!open) return null;

  return (
    <div style={overlayStyle} onClick={onClose}>
      <div style={sheetStyle} onClick={(e) => e.stopPropagation()}>
        <div style={headerStyle}>
          <h3 style={{ margin: 0, fontWeight: 800 }}>Terms & Conditions</h3>
          <button
            type="button"
            onClick={onClose}
            style={{ background: 'transparent', border: 'none', color: 'var(--color-text-secondary)', fontSize: 18, cursor: 'pointer' }}
            aria-label="Close"
          >
            ×
          </button>
        </div>
        <div style={bodyStyle}>
          <TermsContent />
        </div>
      </div>
    </div>
  );
};

export default TermsBottomSheet;


